(() => {
  const revealGroups = document.querySelectorAll(".js-scroll-reveal");

  if (!revealGroups.length) {
    return;
  }

  const showGroup = (group) => {
    group.classList.add("is-visible");
  };

  if (!("IntersectionObserver" in window)) {
    revealGroups.forEach(showGroup);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        const group = entry.target.closest(".js-scroll-reveal") || entry.target;
        showGroup(group);
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: "0px 0px -15% 0px",
      threshold: 0,
    },
  );

  revealGroups.forEach((group) => {
    const trigger = group.querySelector(".js-scroll-reveal-trigger") || group;
    observer.observe(trigger);
  });
})();
